const PREFIX = 'SETTINGS/';
export const RUN_SETTINGS_BY_LOCATION = `${PREFIX}RUN_SETTINGS_BY_LOCATION`;
export const SETTINGS_BY_LOCATION_LIST = `${PREFIX}SETTINGS_BY_LOCATION_LIST`;
export const SET_LOCATION = `${PREFIX}SET_LOCATION`;
